<template>
  <div class="automacao-editor__wizard">
    <div class="automacao-editor__wizard-arvore">
      <p class="automacao-editor__coluna-titulo">Passos</p>
      <p class="automacao-editor__coluna-ajuda">
        Escolha o gatilho e siga as perguntas. Na condição, defina o sim e depois o não.
      </p>
      <ul v-if="errosGerais.length" class="automacao-wizard__avisos automacao-wizard__avisos--geral">
        <li v-for="(item, indice) in errosGerais" :key="indice">{{ item }}</li>
      </ul>

      <automacao-wizard-passo
        v-if="raiz"
        :passo="raiz"
        :selecionado-id="no && no.id"
        :erros-por-no="errosPorNo"
        @selecionar="$emit('selecionar', $event)"
        @adicionar="$emit('adicionar', $event)"
        @remover="$emit('remover', $event)"
      />
      <div v-else class="automacao-wizard__vazio">
        <automacao-wizard-add
          modo="gatilho"
          pergunta="Qual o gatilho?"
          @adicionar="$emit('adicionar', { tipo: $event })"
        />
      </div>
    </div>

    <automacao-sidebar
      :no="no"
      :pipelines="pipelines"
      :fases-por-pipeline="fasesPorPipeline"
      :usuarios-por-pipeline="usuariosPorPipeline"
      :templates="templates"
      :conexoes="conexoes"
      :campos-customizados="camposCustomizados"
      :status="status"
      :oportunidades-do-fluxo="oportunidadesDoFluxo"
      :erros-por-no="errosPorNo"
      @atualizar-no="repassarNo"
    />
  </div>
</template>

<script>
import AutomacaoSidebar from './AutomacaoSidebar.vue'
import AutomacaoWizardAdd from './AutomacaoWizardAdd.vue'
import AutomacaoWizardPasso from './AutomacaoWizardPasso.vue'
import { arvoreDoCanvas } from './automacao-drawflow'

export default {
  name: 'AutomacaoWizard',
  components: {
    AutomacaoSidebar,
    AutomacaoWizardAdd,
    AutomacaoWizardPasso,
  },
  props: {
    editor: {
      type: Object,
      default: null,
    },
    revisao: {
      type: Number,
      default: 0,
    },
    no: {
      type: Object,
      default: null,
    },
    pipelines: {
      type: Array,
      default: function () {
        return []
      },
    },
    fasesPorPipeline: {
      type: Object,
      default: function () {
        return {}
      },
    },
    templates: {
      type: Array,
      default: function () {
        return []
      },
    },
    conexoes: {
      type: Array,
      default: function () {
        return []
      },
    },
    usuariosPorPipeline: {
      type: Object,
      default: function () {
        return {}
      },
    },
    camposCustomizados: {
      type: Array,
      default: function () {
        return []
      },
    },
    status: {
      type: Array,
      default: function () {
        return []
      },
    },
    oportunidadesDoFluxo: {
      type: Array,
      default: function () {
        return [{ id: 'atual', rotulo: 'A que disparou o fluxo' }]
      },
    },
    errosPorNo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    errosGerais: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  computed: {
    raiz() {
      this.revisao
      return arvoreDoCanvas(this.editor)
    },
  },
  methods: {
    repassarNo(id, data) {
      this.$emit('atualizar-no', id, data)
    },
  },
}
</script>
